import styled from 'styled-components'
import { darken } from 'polished'

export const Button = styled.button`
  margin-top: ${props => (props.margin ? '0px' : '20px')};
  border-radius: 5px;
  font-family: Roboto;
  background-color: ${props => (props.color ? props.color : '#fb5561')};
  height: ${props => (props.height ? props.height : '40px')};
  border: ${props => (props.border ? props.border : 'none')};
  padding: 0px 20px;
  color: ${props => (props.textColor ? props.textColor : '#ffffff')};
  font-size: ${props => (props.fontSize ? props.fontSize : '15px')};
  font-weight: ${props => (props.bold === false ? '400' : '600')};

  &:hover {
    background-color: ${props => (props.color ? darken(0.05, props.color) : darken(0.05, '#fb5561'))};
  }

  span {
    text-transform: ${props => (props.uppercase === true ? 'uppercase' : 'initial')};
    color: ${props => (props.textColor ? props.textColor : '#ffffff')} !important;
  }

  &:active {
    vertical-align: top;
    padding: 9px 20px 9px;
  }
`
